<template>
  <v-card class="mt-2">
    <v-toolbar-title class="headingFontsize">
      <div class="ms-4 mt-4"><b>Authorized Person Limitations</b></div>
    </v-toolbar-title>
    <v-divider class="primary--text"></v-divider>
    <v-card-text>
      <v-data-table fixed-header  height="55vh"
        :headers="headers"
        :items="allLimits"
        sort-by="calories"
        :search="search"
        dense
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-dialog persistent v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  depressed
                  color="primary"
                  dark
                  small
                  class="me-3 text-capitalize"
                  v-bind="attrs"
                  v-on="on"
                  @click="isUpdate = false"
                >
                  <v-icon small>mdi-content-save-plus-outline</v-icon>Add
                </v-btn>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Type here to filter the table data."
                    single-line
                    hide-details
                    dense
                    clearable
                  ></v-text-field>
                </v-col>

                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-btn
                  depressed
                  @click="downloadExcelsheet"
                  color="primary"
                  small
                  ><v-icon small>mdi-file-excel-outline</v-icon>Export
                </v-btn>
              </template>
              <v-card flat>
                <v-toolbar color="grey lighten-3 font-weight-bold" flat dense>
                  <span class="subtitleFontsize">{{ formTitle }}</span>
                  <v-spacer></v-spacer>
                  <v-btn depressed small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>

                <v-form ref="complincelimts" v-model="valid" lazy-validation>
                  <v-card-text class="mt-5">
                    <v-row>
                      <v-col cols="12" sm="6" md="6"
                        ><label class="my-0 labelFontsize">
                          Authorized Role
                        </label>
                        <v-autocomplete
                          class="rounded"
                          dense
                          outlined
                          placeholder="Authorized Role"
                          :items="Authorized_role"
                          item-value="value_code"
                          item-text="value"
                          v-model="Compliancetransactionlimit.authorized_roles"
                          :rules="type"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="6"
                        ><label class="my-0 labelFontsize"
                          >Transaction Limit</label
                        >
                        <v-autocomplete
                          class="rounded"
                          dense
                          outlined
                          placeholder="Transaction Limit"
                          :items="Transaction_limit"
                          item-value="value_code"
                          item-text="value"
                          v-model="Compliancetransactionlimit.transaction_limit"
                          :rules="catogry"
                        ></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="6" md="6">
                        <label class="my-0 labelFontsize"> Remit Type </label>
                        <v-autocomplete
                          class="rounded"
                          dense
                          outlined
                          placeholder="Remit Type"
                          :items="remit_Type"
                          item-value="value_code"
                          item-text="value"
                          v-model="Compliancetransactionlimit.remit_type"
                          :rules="Remit"
                        ></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="6" md="6" class="mt-7">
                        <v-switch
                          label="Active"
                          class="ma-0 pa-0 add-check"
                          hide-details
                          v-model="Compliancetransactionlimit.is_active"
                        >
                        </v-switch>
                      </v-col>
                    </v-row> </v-card-text
                ></v-form>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    depressed
                    small
                    color="primary"
                    class="text-capitalize"
                    @click="isUpdate ? updateLimitByid() : postList()"
                  >
                    {{ isUpdate ? "Update" : "Save" }}
                  </v-btn>
                  <v-btn
                    depressed
                    small
                    color="primary"
                    class="text-capitalize ms-2"
                    @click="close"
                    outlined
                  >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon
                    >Cancel
                  </v-btn>
                  <!-- <v-btn depressed  small color="primary" class="text-capitalize">
                      <v-icon small class="me-2">mdi-content-save-edit-outline</v-icon> Update
                      </v-btn>
                      <v-btn depressed 
                        small
                        color="primary"
                        class="text-capitalize ms-2"
                        @click="close"
                        outlined
                      >
                        Cancel
                      </v-btn> -->
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.is_active="{ item }">
          <v-switch
            v-model="item.is_active"
            height="0px"
            color="primary"
            dense
            @change="UpdateauthlimitStatus(item.id, item.is_active)"
          ></v-switch>
        </template>
        <template v-slot:item.actions="{ item }">
          <div>
            <v-icon small class="mr-2" color="primary" @click="editItem(item)">
              mdi-content-save-edit-outline
            </v-icon>
          </div>
        </template>
      </v-data-table>

      <OverlayPageVue :showOverlay="loaderOverlay" />
    </v-card-text>
  </v-card>
</template>

<script>
// import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import alerts from "@/mixins/alerts";
import { compliancelimits } from "@/utils/validationCopy.js";
import commonService from "@/services/CommonService/commonService.js";
import setupService from "@/services/SetupService/setupService.js";
import OverlayPageVue from "@/utils/OverlayPage.vue";
export default {
  mixins: [alerts],
  data: () => ({
    ...compliancelimits,
    loaderOverlay: false,
    dialog: false,
    search: "",
    loader: false,
    openDialog: false,
    valid: true,
    editedIndex: -1,
    allLimits: [],
    limitid: "",
    remit_Type: [],
    Authorized_role: [],
    Transaction_limit: [],
    user_Type: [],
    Stauats: [
      { text: "Active", value: "true" },
      { text: "In-Active", value: "false" },
    ],
    headers: [
      {
        text: "SNo",
        align: "start",
        sortable: false,
        value: "id",
      },
      { text: "Authorized Role", value: "authorized_roles" },
      { text: "Transaction Limit", value: "transaction_limit" },
      { text: "Remit Type", value: "remit_type" },
      { text: "Active", value: "is_active", sortable: false },
      { text: "Action", value: "actions", sortable: false },
    ],
    Compliancetransactionlimit: {
      authorized_roles: "",
      transaction_limit: "",
      remit_type: "",
      is_active: false,
    },
    is_active: false,
    isUpdate: false,
    limit_id: null,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },
  components: {
    // BreadCrumb,

    OverlayPageVue,
  },
  validations() {
    return {};
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  mounted() {
    this.getallauthcompliancelimits();
    // this.getParametersByCode("RMT");
    this.getDropdownByUsertype("ALL", "RMT");
    this.getParametersByCode("ATR");
    this.getParametersByCode("TNL");
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async getDropdownByUsertype(type, code) {
      try {
        const response = await commonService.getDropdownByUsertype(type, code);
        if (response.data.status_code === 200) {
          this.remit_Type = response.data.data.map((ele) => {
            return {
              value: ele.value,
              value_code: ele.value_code,
            };
          });
        }
        console.log("paymentmode", response);
      } catch (error) {
        console.error(error);
      }
    },
    async downloadExcelsheet() {
      if (this.allLimits) {
        this.exportToExcel(
          this.headers,
          this.allLimits,
          "Compilence Trans Limit"
        );
      }
    },
    close() {
      this.dialog = false;
      this.isUpdate = false;
      this.Compliancetransactionlimit = {
        authorized_roles: "",
        transaction_limit: "",
        remit_type: "",
        is_active: false,
      };
      this.$refs.complincelimts.reset();
    },
    editItem(item) {
      console.log("item", item);
      this.dialog = true;
      this.isUpdate = true;
      this.id = item.id;
      // this.$refs.complincelimts.resetValidation();
      this.getallauthcompliancebyid(item);
      this.Compliancetransactionlimit = {
        authorized_roles: "",
        transaction_limit: "",
        remit_type: "",
        is_active: false,
      };
    },
    async getParametersByCode(code) {
      // this.loaderOverlay = true;
      try {
        const response = await commonService.getparameterdropdowns(code);
        if (response.data.status_code === 200) {
          switch (code) {
            // case "RMT":
            //   console.log("RMT codes", response.data);
            //   this.remit_Type = response.data.data.map((ele) => {
            //     return {
            //       value: ele.value,
            //       value_code: ele.value_code,
            //     };
            //   });
            //   break;
            case "ATR":
              console.log("ATR codes", response.data);
              this.Authorized_role = response.data.data.map((ele) => {
                return {
                  value: ele.value,
                  value_code: ele.value_code,
                };
              });
              break;
            case "TNL":
              console.log("TNL codes", response.data);
              this.Transaction_limit = response.data.data.map((ele) => {
                return {
                  value: ele.value,
                  value_code: ele.value_code,
                };
              });
              break;
          }
        }
        //  else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getParametersByCode(code);
        // }
      } catch (error) {
        console.error(error);
      }
    },

    async postList() {
      const validate = this.$refs.complincelimts.validate();
      if (validate) {
        this.loaderOverlay = true;
        try {
          const responseData = await setupService.PostAuth(
            this.Compliancetransactionlimit
          );
          if (responseData && responseData.data.status_code == 200) {
            this.stoploader();
            this.showAlertSuccess(responseData.data.message);
            this.close();
            this.getallauthcompliancelimits();
          }
          // else if (responseData.data.status_code == 401) {
          //   this.returnNewToken();
          //   this.postList();
          // }
          else {
            this.showAlertError(responseData.data.message);
            this.stoploader();
          }
        } catch (error) {
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async updateLimitByid() {
      this.loaderOverlay = true;
      try {
        const responseData = await setupService.updateAuth(
          this.id,
          this.Compliancetransactionlimit
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.close();
          this.getallauthcompliancelimits();
        }
        //  else if (responseData.data.status_code == 401) {
        //   this.returnNewToken();
        //   this.updateLimitByid();
        // }
        else {
          this.showAlertError(responseData.data.message);
          this.stoploader();
        }
      } catch (error) {
        console.log(error.responseData);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
    async UpdateauthlimitStatus(id, is_active) {
      this.loaderOverlay = true;
      try {
        const responseData = await setupService.updateAuthstatus(id, is_active);
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getallauthcompliancelimits();
        }
        // else if (responseData.data.status_code == 401) {
        //   this.returnNewToken();
        //   this.UpdatelimitStatus(id, is_active);
        // }
        else {
          this.showAlertError(responseData.data.message);
          this.stoploader();
        }
      } catch (error) {
        console.log(error.responseData);
        this.showAlertError("Something went wrong please try again later.");
      }
    },

    async getallauthcompliancelimits() {
      this.loaderOverlay = true;
      try {
        const response = await setupService.getallAuths();
        if (response.data.status_code === 200) {
          this.allLimits = response.data.data;
          this.stoploader();
        } else if (response.data.status_code === 401) {
          this.allLimits = [];
          // this.returnNewToken();
          // this.getallauthcompliancelimits();
          // this.stoploader();
        } else {
          this.allLimits == [];
          this.stoploader();
        }
      } catch (error) {
        this.allLimits = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getallauthcompliancebyid(item) {
      this.loaderOverlay = true;
      try {
        const response = await setupService.getAuthbyId(item.id);
        if (response.data.status_code === 200) {
          this.Compliancetransactionlimit = {
            authorized_roles: response.data.data[0].authorized_roles,
            transaction_limit: response.data.data[0].transaction_limit,
            remit_type: response.data.data[0].remit_type,
            is_active: response.data.data[0].is_active,
          };
          this.stoploader();
        } else if (response.data.status_code === 401) {
          this.Compliancetransactionlimit = [];
          // this.returnNewToken();
          // this.getallauthcompliancebyid(item);
          // this.stoploader();
        } else {
          this.Compliancetransactionlimit == [];
          this.stoploader();
        }
      } catch (error) {
        this.Compliancetransactionlimit = [];
        this.stoploader();
        console.error(error);
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
